/**
 * @功能名称: 注册app webview关闭事件， 一旦注册app不会关闭，需要显式的调用关闭
 * @文件名称: registAppClose.js
 * @Date: 2018/12/25 下午4:23.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */

import xyJsBridge from './xyJsBridge'
export default function ( cb) {
  var data = {
    jsfunc: cb
  }
  return xyJsBridge('jsbridge://www.xiaoying.com/app/registInterceptClose',data)
}

